import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseRequestsDataGrid } from "src/components/views/erp/purchase/purchaseRequests/PurchaseRequestsDataGrid.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/purchase/purchaseRequests")({
	staticData: { title: i18n.t("purchase_requests"), legacyViewKey: "purchaseRequestsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <PurchaseRequestsDataGrid isActive={isActive} />;
}
